import { createContext, useContext, type ReactNode } from 'react';

interface OverviewDisplayContextValue {
    showKpis: boolean;
}

const OverviewDisplayContext = createContext<OverviewDisplayContextValue | null>(null);

export function OverviewDisplayProvider({
    children,
    showKpis,
}: {
    children: ReactNode;
    showKpis: boolean;
}) {
    return (
        <OverviewDisplayContext.Provider value={{ showKpis }}>
            {children}
        </OverviewDisplayContext.Provider>
    );
}

export function useOverviewDisplay(): OverviewDisplayContextValue {
    const context = useContext(OverviewDisplayContext);

    if (!context) {
        throw new Error('useOverviewDisplay must be used within an OverviewDisplayProvider.');
    }

    return context;
}
